import { faShoppingBasket } from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "gatsby";
import React from "react";


export default function Quote({ className, count, showQuote }) {

    if( showQuote ) {
        return <Link 
            className={`relative justify-self-end mt-4 px-8 py-4 leading-none uppercase font-semibold text-secondary border border-secondary rounded-full shadow-lg hover:bg-secondary hover:text-white md:mt-0  ${className}`}
            to="/cytat"><FontAwesomeIcon icon={faShoppingBasket} /> Wyświetl wycenę {count
                ? <span
                    style={{top: '-5px', right: '-5px'}}
                    className={`absolute w-7 h-7 bg-primary text-white text-xs rounded-full overflow-hidden text-center leading-7`}
                    aria-label={`you have ${count} quote item${count > 1 ? 's' : ''}`}>{count}</span> 
                : '' }
            </Link>
    }

    return '';
}